'use client';
import { stories } from './mock';
import styled from '@benzinga/themetron';
import React from 'react';
import { FusionSection, FusionSectionContent, FusionSectionText, FusionSectionTitle } from '@benzinga/ui';

const BenzingaStory = () => {
  return (
    <StyledSection whiteBackground>
      <FusionSectionContent paddingHorizontal={false} paddingVertical={false}>
        <FusionSectionTitle>The Benzinga Story</FusionSectionTitle>
        <CardsGrid>
          {stories.map((item, i) => (
            <Card key={i}>
              <CardInner>
                <CardCounter>0{i + 1}</CardCounter>
                <StyledText>{item.title}</StyledText>
                <FusionSectionText>{item.description}</FusionSectionText>
              </CardInner>
            </Card>
          ))}
        </CardsGrid>
      </FusionSectionContent>
    </StyledSection>
  );
};

const StyledSection = styled(FusionSection)`
  padding-top: 56px;
  padding-bottom: 56px;
  @media screen and (max-width: 1279px) {
    padding-top: 48px;
    padding-bottom: 48px;
  }
  @media screen and (max-width: 567px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 16px;

  @media screen and (max-width: 1279px) {
    grid-template-columns: auto auto;
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: auto;
  }
`;

const Card = styled.div`
  position: relative;
  display: flex;
  background: linear-gradient(180deg, rgba(225, 235, 250, 0.4) 0%, #e1ebfa 100%);
  border-radius: 4px;
  padding: 1px;
`;

const CardInner = styled.div`
  background: linear-gradient(180deg, rgba(236, 245, 255, 0.56) 0%, #fff 100%);
  border-radius: 4px;
  padding: 24px;
`;

const CardCounter = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  background: rgba(26, 121, 255, 0.05);
  color: ${props => props.theme.colorPalette.blue500};
  border-radius: 48px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.lg};
  line-height: ${({ theme }) => theme.lineHeight[6]};
  @media screen and (max-width: 767px) {
    width: 40px;
    height: 40px;
  }
`;

const StyledText = styled(FusionSectionText)`
  margin-top: 24px;
  color: ${props => props.theme.colorPalette.gray700};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.lg};
  line-height: ${({ theme }) => theme.lineHeight[6]};
`;

export default BenzingaStory;
